import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { PayrollPeriodIdSelect } from "../selects/PayrollPeriodIdSelect";
import { PayTypeIdSelect } from "../selects/PayTypeIdSelect";


export function AddProcessForm({
	isOpen,
	onClose,
	payrollPeriodId,
	employeePersonalInformationId,
	employeePersonalInformationFullName,
	payTypeId,
	totalEcola,
	totalAllowance,
	totalTax,
	totalDays,
	totalDaysAbsents,
	totalAbsents,
	totalDaysLeaves,
	totalLeaves,
	totalDeduction,
	totalAddition,
	totalAdjustment,
	rate,
	totalNighDiff,
	totalHoursOTRegular,
	totalOTRegular,
	totalHoursOTRegularExceeded,
	totalOTRegularExceeded,
	totalHoursOTRestday,
	totalOTRestday,
	totalHoursOTRestdayExceeded,
	totalOTRestdayExceeded,
	totalHoursOTHolidaySpecial,
	totalOTHolidaySpecial,
	totalHoursOTHolidaySpecialExceeded,
	totalOTHolidaySpecialExceeded,
	totalHoursOTHolidayRegular,
	totalOTHolidayRegular,
	totalHoursOTHolidayRegularExceeded,
	totalOTHolidayRegularExceeded,
	totalHoursOTRestdayHolidaySpecial,
	totalOTRestdayHolidaySpecial,
	totalHoursOTRestdayHolidaySpecialExceeded,
	totalOTRestdayHolidaySpecialExceeded,
	totalHoursOTRestdayHolidayRegular,
	totalOTRestdayHolidayRegular,
	totalHoursOTRestdayHolidayRegularExceeded,
	totalOTRestdayHolidayRegularExceeded,
	totalSSS,
	totalPagibig,
	totalPhilhealth,
	totalHoursUndertime,
	totalUndertime,
	totalHoursLate,
	totalLate,
	totalBasic,
	totalGrossPay,
	totalNetPay,
	dateProcessed,
	userId,
	setPayrollPeriodId,
	setEmployeePersonalInformationId,
	setPayTypeId,
	setTotalEcola,
	setTotalAllowance,
	setTotalTax,
	setTotalDays,
	setTotalDaysAbsents,
	setTotalAbsents,
	setTotalDaysLeaves,
	setTotalLeaves,
	setTotalDeduction,
	setTotalAddition,
	setTotalAdjustment,
	setRate,
	setTotalNighDiff,
	setTotalHoursOTRegular,
	setTotalOTRegular,
	setTotalHoursOTRegularExceeded,
	setTotalOTRegularExceeded,
	setTotalHoursOTRestday,
	setTotalOTRestday,
	setTotalHoursOTRestdayExceeded,
	setTotalOTRestdayExceeded,
	setTotalHoursOTHolidaySpecial,
	setTotalOTHolidaySpecial,
	setTotalHoursOTHolidaySpecialExceeded,
	setTotalOTHolidaySpecialExceeded,
	setTotalHoursOTHolidayRegular,
	setTotalOTHolidayRegular,
	setTotalHoursOTHolidayRegularExceeded,
	setTotalOTHolidayRegularExceeded,
	setTotalHoursOTRestdayHolidaySpecial,
	setTotalOTRestdayHolidaySpecial,
	setTotalHoursOTRestdayHolidaySpecialExceeded,
	setTotalOTRestdayHolidaySpecialExceeded,
	setTotalHoursOTRestdayHolidayRegular,
	setTotalOTRestdayHolidayRegular,
	setTotalHoursOTRestdayHolidayRegularExceeded,
	setTotalOTRestdayHolidayRegularExceeded,
	setTotalSSS,
	setTotalPagibig,
	setTotalPhilhealth,
	setTotalHoursUndertime,
	setTotalUndertime,
	setTotalHoursLate,
	setTotalLate,
	setTotalBasic,
	setTotalGrossPay,
	setTotalNetPay,
	setDateProcessed,
	setUserId,
	setShowEmployeeForm,
	handleSubmit,
}) {
	const [errorState, setErrorState] = useState(false);

	const submit = (e) => {
		if (!payrollPeriodId || !employeePersonalInformationId || !payTypeId) {
			setErrorState(true);
			return;
		}
		handleSubmit(e);
		setErrorState(false);
	};

	const handleClose = () => {
		onClose();
		setPayrollPeriodId("");
		setEmployeePersonalInformationId("");
		setPayTypeId("");
		setTotalEcola("");
		setTotalAllowance("");
		setTotalTax("");
		setTotalDays("");
		setTotalDaysAbsents("");
		setTotalAbsents("");
		setTotalDaysLeaves("");
		setTotalLeaves("");
		setTotalDeduction("");
		setTotalAddition("");
		setTotalAdjustment("");
		setRate("");
		setTotalNighDiff("");
		setTotalHoursOTRegular("");
		setTotalOTRegular("");
		setTotalHoursOTRegularExceeded("");
		setTotalOTRegularExceeded("");
		setTotalHoursOTRestday("");
		setTotalOTRestday("");
		setTotalHoursOTRestdayExceeded("");
		setTotalOTRestdayExceeded("");
		setTotalHoursOTHolidaySpecial("");
		setTotalOTHolidaySpecial("");
		setTotalHoursOTHolidaySpecialExceeded("");
		setTotalOTHolidaySpecialExceeded("");
		setTotalHoursOTHolidayRegular("");
		setTotalOTHolidayRegular("");
		setTotalHoursOTHolidayRegularExceeded("");
		setTotalOTHolidayRegularExceeded("");
		setTotalHoursOTRestdayHolidaySpecial("");
		setTotalOTRestdayHolidaySpecial("");
		setTotalHoursOTRestdayHolidaySpecialExceeded("");
		setTotalOTRestdayHolidaySpecialExceeded("");
		setTotalHoursOTRestdayHolidayRegular("");
		setTotalOTRestdayHolidayRegular("");
		setTotalHoursOTRestdayHolidayRegularExceeded("");
		setTotalOTRestdayHolidayRegularExceeded("");
		setTotalSSS("");
		setTotalPagibig("");
		setTotalPhilhealth("");
		setTotalHoursUndertime("");
		setTotalUndertime("");
		setTotalHoursLate("");
		setTotalLate("");
		setTotalBasic("");
		setTotalGrossPay("");
		setTotalNetPay("");
		setDateProcessed("");
		setUserId("");
		setErrorState(false);
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Add Processed Payroll</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="popUp-body">
							<div className="popUp-item info-item column">
								<div className="info-item-label">Employee</div>
								<div className="info-item-input">
									<div
										className="info-item-holder employee-select row"
										style={{ flexDirection: "row", justifyContent: "normal" }}
									>
										<input
											readOnly
											className="employeeInput-select"
											placeholder="Employee"
											value={
												employeePersonalInformationId
													? employeePersonalInformationFullName
													: employeePersonalInformationId
											}
										/>
										<button
											className="select row"
											onClick={() => setShowEmployeeForm(true)}
										>
											<SearchIcon />
										</button>
									</div>
									<span
										style={{
											visibility:
												!employeePersonalInformationId && errorState
													? "visible"
													: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Payroll Period</div>
									<div className="info-item-input">
										<PayrollPeriodIdSelect
											payrollPeriodId={payrollPeriodId}
											setPayrollPeriodId={setPayrollPeriodId}
										/>
									</div>
									<span
										style={{
											visibility:
												!payrollPeriodId && errorState ? "visible" : "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Pay Type</div>
									<div className="info-item-input">
										<PayTypeIdSelect
											payTypeId={payTypeId}
											setPayTypeId={setPayTypeId}
										/>
									</div>
									<span
										style={{
											visibility:
												!payTypeId && errorState ? "visible" : "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Ecola</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Ecola"
											value={totalEcola}
											onChange={(e) => setTotalEcola(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Allowance</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Allowance"
											value={totalAllowance}
											onChange={(e) => setTotalAllowance(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Tax</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Tax"
											value={totalTax}
											onChange={(e) => setTotalTax(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Days</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Days"
											value={totalDays}
											onChange={(e) => setTotalDays(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Days Absents</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Days Absents"
											value={totalDaysAbsents}
											onChange={(e) => setTotalDaysAbsents(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Absents</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Absents"
											value={totalAbsents}
											onChange={(e) => setTotalAbsents(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Days Leaves</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Days Leaves"
											value={totalDaysLeaves}
											onChange={(e) => setTotalDaysLeaves(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Leaves</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Leaves"
											value={totalLeaves}
											onChange={(e) => setTotalLeaves(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Deduction</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Deduction"
											value={totalDeduction}
											onChange={(e) => setTotalDeduction(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Addition</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Addition"
											value={totalAddition}
											onChange={(e) => setTotalAddition(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Adjustment</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Adjustment"
											value={totalAdjustment}
											onChange={(e) => setTotalAdjustment(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Rate</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Rate"
											value={rate}
											onChange={(e) => setRate(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Night Diff</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Night Diff"
											value={totalNighDiff}
											onChange={(e) => setTotalNighDiff(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Hours OT Regular</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Regular"
											value={totalHoursOTRegular}
											onChange={(e) => setTotalHoursOTRegular(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total OT Regular</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Regular"
											value={totalOTRegular}
											onChange={(e) => setTotalOTRegular(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Regular Exceeded"
											value={totalHoursOTRegularExceeded}
											onChange={(e) =>
												setTotalHoursOTRegularExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Regular Exceeded"
											value={totalOTRegularExceeded}
											onChange={(e) =>
												setTotalOTRegularExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Hours OT Restday</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday"
											value={totalHoursOTRestday}
											onChange={(e) => setTotalHoursOTRestday(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total OT Restday</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday"
											value={totalOTRestday}
											onChange={(e) => setTotalOTRestday(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Restday Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday Exceeded"
											value={totalHoursOTRestdayExceeded}
											onChange={(e) =>
												setTotalHoursOTRestdayExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Restday Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday Exceeded"
											value={totalOTRestdayExceeded}
											onChange={(e) =>
												setTotalOTRestdayExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Holiday Special
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Holiday Special"
											value={totalHoursOTHolidaySpecial}
											onChange={(e) =>
												setTotalHoursOTHolidaySpecial(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Holiday Special
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Holiday Special"
											value={totalOTHolidaySpecial}
											onChange={(e) => setTotalOTHolidaySpecial(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Holiday Special Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Holiday Special Exceeded"
											value={totalHoursOTHolidaySpecialExceeded}
											onChange={(e) =>
												setTotalHoursOTHolidaySpecialExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Holiday Special Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Holiday Special Exceeded"
											value={totalOTHolidaySpecialExceeded}
											onChange={(e) =>
												setTotalOTHolidaySpecialExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Holiday Regular
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Holiday Regular"
											value={totalHoursOTHolidayRegular}
											onChange={(e) =>
												setTotalHoursOTHolidayRegular(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Holiday Regular
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Holiday Regular"
											value={totalOTHolidayRegular}
											onChange={(e) => setTotalOTHolidayRegular(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Holiday Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Holiday Regular Exceeded"
											value={totalHoursOTHolidayRegularExceeded}
											onChange={(e) =>
												setTotalHoursOTHolidayRegularExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Holiday Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Holiday Regular Exceeded"
											value={totalOTHolidayRegularExceeded}
											onChange={(e) =>
												setTotalOTHolidayRegularExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Restday Holiday Special
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday Holiday Special"
											value={totalHoursOTRestdayHolidaySpecial}
											onChange={(e) =>
												setTotalHoursOTRestdayHolidaySpecial(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Restday Holiday Special
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday Holiday Special"
											value={totalOTRestdayHolidaySpecial}
											onChange={(e) =>
												setTotalOTRestdayHolidaySpecial(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Restday Holiday Special Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday Holiday Special Exceeded"
											value={totalHoursOTRestdayHolidaySpecialExceeded}
											onChange={(e) =>
												setTotalHoursOTRestdayHolidaySpecialExceeded(
													e.target.value
												)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Restday Holiday Special Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday Holiday Special Exceeded"
											value={totalOTRestdayHolidaySpecialExceeded}
											onChange={(e) =>
												setTotalOTRestdayHolidaySpecialExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Restday Holiday Regular
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday Holiday Regular"
											value={totalHoursOTRestdayHolidayRegular}
											onChange={(e) =>
												setTotalHoursOTRestdayHolidayRegular(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Restday Holiday Regular
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday Holiday Regular"
											value={totalOTRestdayHolidayRegular}
											onChange={(e) =>
												setTotalOTRestdayHolidayRegular(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total Hours OT Restday Holiday Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours OT Restday Holiday Regular Exceeded"
											value={totalHoursOTRestdayHolidayRegularExceeded}
											onChange={(e) =>
												setTotalHoursOTRestdayHolidayRegularExceeded(
													e.target.value
												)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">
										Total OT Restday Holiday Regular Exceeded
									</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total OT Restday Holiday Regular Exceeded"
											value={totalOTRestdayHolidayRegularExceeded}
											onChange={(e) =>
												setTotalOTRestdayHolidayRegularExceeded(e.target.value)
											}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total SSS</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total SSS"
											value={totalSSS}
											onChange={(e) => setTotalSSS(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Pagibig</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Pagibig"
											value={totalPagibig}
											onChange={(e) => setTotalPagibig(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Philhealth</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Philhealth"
											value={totalPhilhealth}
											onChange={(e) => setTotalPhilhealth(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Hours Undertime</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours Undertime"
											value={totalHoursUndertime}
											onChange={(e) => setTotalHoursUndertime(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Undertime</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Undertime"
											value={totalUndertime}
											onChange={(e) => setTotalUndertime(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Hours Late</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Hours Late"
											value={totalHoursLate}
											onChange={(e) => setTotalHoursLate(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Late</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Late"
											value={totalLate}
											onChange={(e) => setTotalLate(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Basic</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Basic"
											value={totalBasic}
											onChange={(e) => setTotalBasic(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Gross Pay</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Gross Pay"
											value={totalGrossPay}
											onChange={(e) => setTotalGrossPay(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Total Net Pay</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="Total Net Pay"
											value={totalNetPay}
											onChange={(e) => setTotalNetPay(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">User ID</div>
									<div className="info-item-input">
										<input
											type="number"
											placeholder="User ID"
											value={userId}
											onChange={(e) => setUserId(e.target.value)}
										/>
									</div>
									<span
										style={{
											visibility: "hidden",
											color: "#ff6565",
											fontSize: "12px",
										}}
									>
										Please fill up this field
									</span>
								</div>
							</div>
						</div>
						<div
							className="buttons row"
							style={{ justifyContent: "end", padding: "20px 40px" }}
						>
							<button
								id="add-family"
								className="save row"
								onClick={(e) => submit(e)}
							>
								SAVE
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}